import { useContext } from 'react'

import { ViewportContext } from 'context/ViewportContext/ViewportContext'

/**
 * @typedef {import('context/ViewportContext/types').Viewport} Viewport
 */

/**
 * @returns {{
 *   currentViewport: Viewport,
 *   is: (viewport: Viewport) => boolean,
 *   up: (viewport: Viewport) => boolean,
 *   down: (viewport: Viewport) => boolean,
 *   between: (from: Viewport, to: Viewport) => boolean
 * }}
 */
const useViewport = () => {
  const context = useContext(ViewportContext)

  if (!context) {
    throw new Error('useViewport must be used within a ViewportContext')
  }

  return context
}

export default useViewport
